__turbopack_context__.v({
  "isTabActive": "tabList-module-scss-module__Au6S0G__isTabActive",
  "tab": "tabList-module-scss-module__Au6S0G__tab",
  "tabs": "tabList-module-scss-module__Au6S0G__tabs",
});
